import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { SnackbarProvider } from '@/app/utils/useSnackbar';

import reportWebVitals from './reportWebVitals';
import './index.css';
import './i18n';
import '@/app/utils/custom_function';
import { pdfjs } from 'react-pdf';

const container = document.getElementById('root')!;
const host = window.location.hostname.toLowerCase();
const isAdminHost = host === 'admin.localhost' || host.startsWith('admin.');
const isLandingHost = host === 'padelmatchapp.com' || host === 'www.padelmatchapp.com';
// Boot diagnostics for host-based routing
try {
  console.log('[boot] host:', host, 'isAdminHost:', isAdminHost, 'isLandingHost:', isLandingHost);
  (window as any).__pm_boot = { host, isAdminHost, isLandingHost };
} catch {}
const root = createRoot(container);

const LandingPage = lazy(() => import('@/app/features/landing'));
const App = lazy(() => import('@/App'));
const AdminApp = lazy(() => import('@/admin/App'));

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

root.render(
  <SnackbarProvider>
    <Provider store={store}>
      <Suspense
        fallback={
          <div style={{
            height: '100%', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white'
          }}>
            Loading...
          </div>
        }
      >
        {isLandingHost ? <LandingPage /> : isAdminHost ? <AdminApp /> : <App />}
      </Suspense>
    </Provider>
  </SnackbarProvider>
);

reportWebVitals();